import { SliderDisplayNumber } from "@/components/form/slider/SliderDisplayNumber";
import { SliderSkeleton } from "@/components/form/slider/SliderSkeleton";
import { Label } from "@/components/text/Label";
import { SoftText } from "@/components/text/SoftText";

type SliderProps = React.ComponentProps<typeof SliderSkeleton>;

export function Slider({
  label,
  description,
  sliderProps,
  decimalToPercent,
  className,
  dataTutorial,
}: {
  label: string;
  description: string;
  sliderProps: SliderProps;
  decimalToPercent: boolean;
  className?: string;
  dataTutorial?: string;
}) {
  // Slider can have maximum of 2 values
  if (sliderProps.value === undefined || sliderProps.value.length === 0) {
    return null;
  }

  return (
    <div className={className} data-tutorial={dataTutorial}>
      <Label elementType="label">{label}</Label>
      <SoftText
        elementType="p"
        className="mb-2 mt-1 text-sm font-normal text-gray-500"
      >
        {description}
      </SoftText>

      <div className="flex items-center">
        {sliderProps.value.length === 2 && (
          <SliderDisplayNumber
            value={sliderProps.value[0]}
            decimalToPercent={decimalToPercent}
            className="mr-4"
          />
        )}
        <SliderSkeleton {...sliderProps} className="flex-grow" />
        <SliderDisplayNumber
          value={
            sliderProps.value.length === 2 ?
              sliderProps.value[1]
            : sliderProps.value[0]
          }
          decimalToPercent={decimalToPercent}
          className="ml-4"
        />
      </div>
    </div>
  );
}
